const stripTrailingSlash = (url: string) => url.replace(/\/$/, '');

// CMS records store the English path without a language prefix
// (https://hawc-servers.com/categories). The site serves
// /en/categories and /pl/kategorie. Map the live path back to that
// stored URL so the existing records match.
export const toCmsUrl = (
  pathname: string,
  domain: string,
  localizedRoutes: Record<string, string>,
  englishRoutes: Record<string, string>
) => {
  const base = stripTrailingSlash(domain);
  const segments = pathname.split('/').filter(Boolean);
  const rest = segments.slice(1);

  const slugToKey = new Map<string, string>();
  Object.entries(localizedRoutes).forEach(([key, slug]) => {
    if (slug && !slug.includes('/')) {
      slugToKey.set(slug, key);
    }
  });

  if (rest.length > 0) {
    const key = slugToKey.get(rest[0]);
    const englishSlug = key ? englishRoutes[key] : undefined;
    if (englishSlug && !englishSlug.includes('/')) {
      rest[0] = englishSlug;
    }
  }

  const path = rest.join('/');
  return path ? `${base}/${path}` : base;
};

export const alternatePath = (
  pathname: string,
  targetLang: string,
  localizedRoutes: Record<string, string>,
  targetRoutes: Record<string, string>
) => {
  const rest = pathname.split('/').filter(Boolean).slice(1);
  const slugToKey = new Map<string, string>();
  Object.entries(localizedRoutes).forEach(([key, slug]) => {
    if (slug && !slug.includes('/')) {
      slugToKey.set(slug, key);
    }
  });

  if (rest.length > 0) {
    const key = slugToKey.get(rest[0]);
    const targetSlug = key ? targetRoutes[key] : undefined;
    if (targetSlug && !targetSlug.includes('/')) {
      rest[0] = targetSlug;
    }
  }

  return rest.length ? `/${targetLang}/${rest.join('/')}` : `/${targetLang}`;
};

export const pageUrls = (
  pathname: string,
  domain: string,
  localizedRoutes: Record<string, string>,
  englishRoutes: Record<string, string>,
  polishRoutes: Record<string, string>
) => {
  const base = stripTrailingSlash(domain);
  const current = pathname.split('?')[0].replace(/\/$/, '') || '/en';
  const enPath = alternatePath(pathname, 'en', localizedRoutes, englishRoutes);
  const plPath = alternatePath(pathname, 'pl', localizedRoutes, polishRoutes);
  return {
    canonical: `${base}${current}`,
    alternates: [
      { hrefLang: 'en', href: `${base}${enPath}` },
      { hrefLang: 'pl', href: `${base}${plPath}` },
      { hrefLang: 'x-default', href: `${base}${enPath}` },
    ],
  };
};

export const isCategoryProductPath = (
  pathname: string,
  lang: string,
  categoriesSlug: string
) => {
  const segments = pathname.split('/').filter(Boolean);
  return (
    segments.length >= 4 &&
    segments[0] === lang &&
    segments[1] === categoriesSlug
  );
};
